import { bind } from '@/search/input'

$(() => {
  bind()
})
